module.exports = __webpack_public_path__ + "static/media/gronsakshjalpen_montage.b9e43d4c.jpg";